// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetEventRegistrationQuestionsRequestModel from '../../model/get-widget-event-registration-questions-request-model';
import GetWidgetEventRegistrationQuestionsRequestDTO from '../dto/get-widget-event-registration-questions-request-dto';
import dtoSchema from '../schemas/get-widget-event-registration-questions-request-schema';

export default abstract class GetWidgetEventRegistrationQuestionsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetEventRegistrationQuestionsRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int32}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetWidgetEventRegistrationQuestionsRequestDTO>): GetWidgetEventRegistrationQuestionsRequestModel;
  static toModel(dto: DeepPartial<GetWidgetEventRegistrationQuestionsRequestDTO> | undefined | null): GetWidgetEventRegistrationQuestionsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetEventRegistrationQuestionsRequestDTO> | undefined | null): GetWidgetEventRegistrationQuestionsRequestModel | undefined {
    return dto ? new GetWidgetEventRegistrationQuestionsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetEventRegistrationQuestionsRequestModel> | GetWidgetEventRegistrationQuestionsRequestModel): GetWidgetEventRegistrationQuestionsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetWidgetEventRegistrationQuestionsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetEventRegistrationQuestionsRequestModel, can not map to GetWidgetEventRegistrationQuestionsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
